import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ISalary } from "src/types/atoms";
const Salary = ({
  label,
  value,
  color = grey[600],
  simple = true,
  weight = 400
}: ISalary) => {
  const classes = {
    root: {
      marginTop: 1,
      backgroundColor: simple ? "transparent" : grey[100],
      padding: 1,
      borderRadius: 2
    }
  };
  return <Box sx={classes.root}>
      <Typography color={grey[700]} fontWeight={700}>
        {label}
      </Typography>
      <Typography color={color} fontWeight={weight} fontSize={simple ? "1rem" : "1.2rem"} marginLeft={0.5}>
        {value}
      </Typography>
    </Box>;
};
export default Salary;